<template lang="slm">
  div
    .section.header
      h2 Создать обьявление
    .section
      .container.text-left
        form
          .form-group
            label Заголовок обьявления
            input.form-control type='text' name='title' v-model='item.title' v-validate='"required"'
            small.text-danger v-show="errors.has('title')" {{ errors.first('title') }}
          .form-group
            label Описание обьявления
            textarea.form-control name='description' v-model='item.description' v-validate='"required"'
            small.text-danger v-show="errors.has('description')" {{ errors.first('description') }}
          .form-group
            label Категория
            input.form-control type='text' name='category' v-model='item.category' v-validate='"required"'
            small.text-danger v-show="errors.has('category')" {{ errors.first('category') }}
          .form-group
            label ФИО
            input.form-control type='text' name='fio' v-model='item.fio' v-validate='"required"'
            small.text-danger v-show="errors.has('fio')" {{ errors.first('fio') }}
          .form-group
            label Электронная почта
            input.form-control type='email' name='email' v-model='item.email' v-validate='"required"'
            small.text-danger v-show="errors.has('email')" {{ errors.first('email') }}
          .form-group
            label Телефон
            input.form-control type='text' name='phone_number' v-model='item.phone_number' v-validate='"required"'
            small.text-danger v-show="errors.has('phone_number')" {{ errors.first('phone_number') }}
          .form-group
            .d-block
              input#show_phone_number type='checkbox' name='show_phone_number' v-model='item.show_phone_number'
              label.ml-2.mb-0 for='show_phone_number' Показывать мой номер
            .d-block
              input#from_church type='checkbox' name='from_church' v-model='item.from_church'
              label.ml-2.mb-0 for='from_church' Я человек из церкви
</template>

<style lang="stylus" scoped>
.section
  background-color white
</style>

<script>
// import gql from 'graphql-tag';

export default {
  name: 'CreateAnnouncementPage',
  data() {
    return {
      item: {
        title: '',
        description: '',
        category: '',
        fio: '',
        email: '',
        phone_number: '',
        show_phone_number: true,
        from_church: true,
      },
    };
  },
};
</script>
